<template lang="pug">
    section
        .custom-settings(v-if="settings.length && settings.filter(setting => checkConditions(setting)).length")
            //- hr(v-if="settings.length && settings.filter(setting => checkConditions(setting)).length" key="hr")
            transition-group(name="slide-decent-vertical" mode="in-out")
                .setting(
                    v-for="setting in settings" :key="setting.key"
                    v-if="checkConditions(setting)"
                    :class="setting.key"
                )
                    input-field(
                        :config="setting"
                        :content="settingValues"
                        :options="options"
                        :edit="true"
                        @change="updateSetting"
                    )
</template>

<script>
import _ from 'lodash'
import { timestamp2date } from '@/filters'
import echo from '@/echo'
import { useAuthStore, useSetupStore, usePageStore, useNewsletterNewsletterStore } from '@/stores'

import InputField from '@/components/Page/Sections/Partials/InputField'

export default {
    name: 'NewsletterSettings',
    components: {
        InputField,
    },
    computed: {
        pageStore() {
            return usePageStore()
        },
        page() {
            return this.pageStore.form
        },
        settings() {
            return _.get(this.activeCms, 'config.template.newsletter.settings') || []
        },
        settingValues() {
            let settingValues = {}
            let options = {}

            // menu item settings
            const settings = _.get(this.page, 'settings') || []

            // select fields
            // get default values
            // so that invalid values can be determined
            if (this.settings && this.settings.length) {
                this.settings.forEach(setting => {
                    if (setting.options && setting.options.length) {
                        // const option = setting.options.find(option => option.default === true)
                        setting.options.forEach(option => {
                            if (option.default === true && ! settings.find(el => el.key === setting.key)) {
                                if (['multi-select', 'tags'].includes(setting.type)) {
                                    if (! settingValues[setting.key]) settingValues[setting.key] = []
                                    settingValues[setting.key].push({ key: option.key, value: option.value })
                                }
                                else settingValues[setting.key] = option.key
                            }
                            _.set(options, `${setting.key}.${option.key}`, option.value)
                        })
                    } else {
                        switch (setting.type) {
                            case 'checkbox':
                            case 'switch':
                                settingValues[setting.key] = false
                                if (setting.value) {
                                    settingValues[setting.key] = ['true', '1', 'yes', true].includes(setting.value)
                                }
                                break;

                            default:
                                settingValues[setting.key] = setting.value
                        }
                    }
                })
            }

            // override with actual values
            if (this.page.settings && this.page.settings.length) {
                this.page.settings.forEach(setting => {
                    // check if selected option exists

                    // get related configuration (defined in temaplte JSON)
                    const config = this.settings.find(el => el.key === setting.key)
                    const type = _.get(config, 'type')

                    switch (type) {
                        case 'select':
                        case 'multi-select':
                        case 'tags':
                            if (setting.key && setting.value != null && _.get(options, `${setting.key}.${setting.value}`) !== undefined) {
                                settingValues[setting.key] = setting.value
                            } else if (setting.options && setting.options.length) {
                                settingValues[setting.key] = setting.options
                            }
                            break;

                        case 'checkbox':
                        case 'switch':
                            settingValues[setting.key] = false
                            if (setting.value) {
                                settingValues[setting.key] = ['true', '1', 'yes', true].includes(setting.value)
                            }
                            break;

                        default:
                            settingValues[setting.key] = setting.value
                    }
                })
            }

            return settingValues
        },
        rights() {
            return useAuthStore().rights;
        },
        isSuperuser() {
            return useAuthStore().isSuperUser;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        newsletterStore() {
            return useNewsletterNewsletterStore()
        },
        form() {
            return this.newsletterStore.form
        },
        options() {
            return this.newsletterStore.options
        },
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        updateSetting(payload) {
            if (payload.value && _.isArray(payload.value)) {
                this.pageStore.setFormSettingsOptions({ key: payload.key, options: payload.value })
            } else {
                this.pageStore.setFormSettingsValue({ key: payload.key, value: payload.value })
            }
        },
    },
}
</script>

<style lang="sass" scoped>
:deep()
    .setting
        padding: 10px 0
        .divider
            margin:0
</style>
